import React, { useEffect, useRef, useState } from "react";
import Table from "../../components/common/table/Table";
import ExcelExport from "../../components/common/ui/Export/ExcelExport";
import Button from "../../components/common/ui/Button";
import { SelectInput } from "../../components/common/ui/Inputs";
import DateInput from "./../../components/common/ui/Inputs/DateInput";
import { history } from "../../_helpers";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { inmateAction, masterActions } from "../../_store";
import { fDate, MinDate, Today } from "../../utils/formatTime";
import CustomLoader from "../../components/common/ui/Loader";
import PDFExport from "../../components/common/ui/Export/PDFExport";
import PrintExport from "../../components/common/ui/Export/PrintExport";
import generatePDFDebit from "../../components/common/export/generatePDFDebit";
import { useReactToPrint } from "react-to-print";

function InmateDebitHistory() {
  const location = useLocation();
  const { inmate: Inmate } = location.state || {};

  const { inmateInfoTabData, debitList, debitFullList, loading, inmate } =
    useSelector((x) => x.inmate);
  const { AccountType, TransactionType } = useSelector(
    (x) => x.dropdownOptions
  );
  const { facilityDropDown } = useSelector((state) => state.master);

  const { commonFacilityCode } = useSelector((state) => state.auth);

  const FacilityName = facilityDropDown?.find(
    (item) => item?.value === parseInt(commonFacilityCode)
  )?.label;

  const dispatch = useDispatch();

  const [debit, setDebit] = useState({
    FacilityID: 0,
    InmatesId: 0,
    AccountTypeId: 0,
    AccountType: "",
    TransactionTypeId: 0,
    TransactionType: "",
    FromDate: "",
    ToDate: "",
    PageNo: 1,
    RowCountPerPage: 10,
    SortBy: "",
  });

  const [showSearchFields, setShowSearchFields] = useState(false);

  useEffect(() => {
    dispatch(
      masterActions.LoadFacilityDropDown({
        facilityID: 0,
        activeStatus: 1,
      })
    );
  }, [dispatch]);

  useEffect(() => {
    let updateParam = {
      ...debit,
      InmatesId: Inmate?.InmateID || inmate?.InmateID,
      FacilityID: Inmate?.facilityID || inmate?.facilityID,
    };
    setDebit(updateParam);
    dispatch(inmateAction.LoadCactasTransactionHistory(updateParam));
  }, []);

  const columns = [
    {
      name: "Account Type",
      key: "Accounttype",
      selector: (row) => row.TransactionFrom,
      sortable: true,
    },
    {
      name: "Transaction Type",
      key: "Transactiontype",
      selector: (row) => row.TransactionType,
      sortable: true,
    },
    {
      name: "Amount ($)",
      key: "Amount",
      selector: (row) => row.DebitAmount.toFixed(2),
      sortable: true,
    },
    {
      name: "Date",
      key: "Date",
      selector: (row) => row.TransactionDate,
      sortable: true,
    },
  ];

  let updatedDebit = { ...debit };

  const handleSelectChange = (selectedOption, name) => {
    switch (name) {
      case "AccountType":
        updatedDebit[name] =
          selectedOption?.label === "-- Select --" ? "" : selectedOption?.label;
        updatedDebit.AccountTypeId = selectedOption?.value || 0;
        updatedDebit.PageNo = 1;
        updatedDebit.RowCountPerPage = 10;
        updatedDebit.SortBy = "";

        dispatch(inmateAction.LoadCactasTransactionHistory(updatedDebit));
        break;
      case "TransactionType":
        updatedDebit[name] =
          selectedOption?.label === "-- Select --" ? "" : selectedOption?.label;
        updatedDebit.TransactionTypeId = selectedOption?.value || 0;
        updatedDebit.PageNo = 1;
        updatedDebit.RowCountPerPage = 10;
        updatedDebit.SortBy = "";
        dispatch(inmateAction.LoadCactasTransactionHistory(updatedDebit));
        break;

      default:
        break;
    }
    setDebit(updatedDebit);
  };

  const handleDateChange = (value, name) => {
    const date = fDate(value);
    updatedDebit[name] = date;

    setDebit(updatedDebit);
  };

  const handleDateEnterKey = (event, name) => {
    if (event.key === "Enter" && updatedDebit[name] === "") {
      const currentDate = new Date();

      // Set today's date using the same logic as your handleDateChange
      handleDateChange(currentDate, name);
    }

    const regex = /^[0-9/]$/; // Allow numbers and "/"

    if (
      !regex.test(event.key) &&
      event.key !== "Backspace" &&
      event.key !== "Delete" &&
      !(event.ctrlKey && event.key === "v")
    ) {
      event.preventDefault();
    }

    // Auto-insert '/' when typing
    const input = event.target.value;

    if (event.key !== "Backspace" && event.key !== "Delete") {
      if (input?.length === 2 || input?.length === 5) {
        event.target.value = input + "/";
      }
    }
  };

  const handleDateBlur = (e, fieldName) => {
    let { value } = e.target;
    let isFromValid = true;
    let isToValid = true;

    if (fieldName === "FromDate") {
      if (
        updatedDebit.ToDate &&
        new Date(value) > new Date(updatedDebit.ToDate)
      ) {
        // Invalid: FromDate cannot be after ToDate
        isFromValid = false;
      }
    } else if (fieldName === "ToDate") {
      if (
        updatedDebit.FromDate &&
        new Date(value) < new Date(updatedDebit.FromDate)
      ) {
        // Invalid: ToDate cannot be before FromDate
        isToValid = false;
      }
    }
    // Define date format used
    const minDate = MinDate();
    const today = Today();
    const valueDate = new Date(value);
    const isValidDate = valueDate >= minDate && valueDate <= today;

    let updatedParam = {
      ...updatedDebit,
      FromDate:
        fieldName === "FromDate"
          ? isFromValid && isValidDate
            ? value
            : ""
          : updatedDebit.FromDate, // preserve existing value
      ToDate:
        fieldName === "ToDate"
          ? isToValid && isValidDate
            ? value
            : ""
          : updatedDebit.ToDate, // preserve existing value
    };

    setDebit(updatedParam);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    dispatch(inmateAction.LoadCactasTransactionHistory(debit));
  };

  const initialData = {
    ...debit,
    AccountTypeId: 0,
    AccountType: "",
    TransactionTypeId: 0,
    TransactionType: "",
    FromDate: "",
    ToDate: "",
    PageNo: 1,
    RowCountPerPage: 10,
    SortBy: "",
  };

  const handleReset = () => {
    setDebit(initialData);
    dispatch(inmateAction.LoadCactasTransactionHistory(initialData));
  };

  //Pagination
  const [initialLoad, setInitialLoad] = useState(true);
  useEffect(() => {
    if (!initialLoad) {
      dispatch(inmateAction.LoadCactasTransactionHistory(debit));
    }
  }, [debit?.PageNo, debit?.RowCountPerPage]);

  const handlePageChange = (pageNo) => {
    if (iSorting) {
      iSorting = false;
      return;
    }
    setInitialLoad(false);
    setDebit((prev) => ({
      ...prev,
      PageNo: pageNo,
    }));
  };

  const handleRowPerPage = (rowCount) => {
    setInitialLoad(false);
    setDebit((prev) => ({
      ...prev,
      PageNo: 1,
      RowCountPerPage: rowCount,
    }));
  };

  let iSorting = false;
  const handleSort = (column, sortDirection) => {
    if (!column?.key) return;
    iSorting = true;
    const search = { ...debit };
    const newSortOrder = search?.SortBy?.includes(column.key)
      ? search?.SortBy?.endsWith("asc")
        ? "desc"
        : "asc"
      : "asc";

    search.SortBy = `${column.key} ${newSortOrder}`;
    setDebit(search);
    dispatch(
      inmateAction.LoadCactasTransactionHistory({
        ...debit,
        SortBy: `${column.key} ${newSortOrder}`,
      })
    );
  };

  const handleClickPDF = () => {
    let updatedParam = {
      ...debit,
      PageNo: 1,
      RowCountPerPage: debitList?.TotalRecordCount,
      exportExcel: true,
    };

    dispatch(inmateAction.LoadCactasTransactionHistory(updatedParam)).then(
      (res) => {
        const title = `${Inmate?.InmateResidentId}_Inmate Debit History_${fDate(
          new Date()
        )}`;

        let result = res?.payload;

        // Transform data into the required format
        const CactasTransactionData = result?.DataList?.map((obj) => ({
          "Account Type": obj?.TransactionFrom,
          "Transaction Type": obj?.TransactionType,
          "Amount ($)": obj?.DebitAmount?.toFixed(2),
          Date: obj?.TransactionDate,
        }));

        // Prepare table headers and rows dynamically
        const prepareTableData = (dataArray) => {
          if (dataArray.length === 0) return { headers: [], rows: [] };

          // Extract headers from the keys of the first object
          const headers = Object.keys(dataArray[0]);

          // Extract rows from the values of each object
          const rows = dataArray.map((item) => Object.values(item));

          return { headers, rows };
        };

        const { headers, rows } = prepareTableData(CactasTransactionData);

        const totalDebitAmount = result?.DataList[0]?.DebitTotalAmount;
        const totalCreditAmount = result?.DataList[0]?.CreditTotalAmount;
        const facilityName = FacilityName; // Replace with dynamic data
        const inmateName = Inmate?.InmateFullName || inmate?.InmateFullName; // Replace with dynamic data
        const inmateId = Inmate?.InmateResidentId || inmate?.InmateResidentId; // Replace with dynamic data

        generatePDFDebit(
          facilityName,
          inmateName,
          inmateId,
          headers,
          rows,
          totalDebitAmount,
          totalCreditAmount,
          false,
          title
        );
      }
    );
  };

  //Print
  const componentRef = useRef(); // Reference to the component that will be printed

  const [isPrintData, setIsPrintData] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // Monitor changes to `debitFullList` to determine when data is loaded
  useEffect(() => {
    if (isLoading && debitFullList?.DataList?.length > 0) {
      setIsPrintData(true);
      setTimeout(() => {
        handlePrints();
      }, 5);
      setTimeout(() => {
        setIsPrintData(false);
        setIsLoading(false); // Reset loading state
      }, 200); // Give enough time for print operation
    }
  }, [debitFullList, isLoading]);

  const handlePrints = useReactToPrint({
    pageStyle: `@media print {
      @page {
       size: A4 portrait;
        margin: 2 !important;
         padding: 2 !important;
      }
      body {
        height: auto !important;
        overflow: hidden !important;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }

      * {
        
        font-size: 16px !important;
      }

      table, th, td {
        border: 2px solid black !important;
      }

      .print-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        break-inside: avoid;
        page-break-inside: avoid;
      }

      .print-date {
        position: absolute;
        top: 10px;
        right: 20px;
        font-size: 14px;
        font-weight: bold;
      }
    }
  `,

    content: () => componentRef.current,
    onBeforeGetContent: () => { },
  });

  const handlePrintShow = () => {
    const updatedParam = {
      ...debit,
      PageNo: 1,
      RowCountPerPage: debitList?.TotalRecordCount,
      exportExcel: true,
    };

    setIsLoading(true); // Set loading state to true
    dispatch(inmateAction.LoadCactasTransactionHistory(updatedParam));
  };

  if (loading) {
    return <CustomLoader />;
  }

  const toggleInformation = () => {
    setShowSearchFields((prev) => !prev);
  };

  const renderSearch = () => {
    return (
      <form onSubmit={handleSubmit}>
        {/* First Row: Username, Last Name, First Name */}
        <div className="row">
          <div className="p-2 m-1 d-flex flex-wrap align-items-center">
            {/* Frequency */}
            <div className="col-md-3 col-sm-12 d-flex flex-wrap align-items-center me-1">
              <label className="fs-5" style={{ minWidth: "150px" }}>
                Inmate Last Name :
              </label>
              <strong className="fs-5 text-end">
                {Inmate?.LastName ||
                  inmate?.LastName ||
                  (inmateInfoTabData && inmateInfoTabData[0]?.LastName)}
              </strong>
            </div>

            {/* Limit */}
            <div className="col-md-3 col-sm-12 d-flex flex-wrap align-items-center">
              <label className="fs-5" style={{ minWidth: "150px" }}>
                Inmate First Name :
              </label>
              <strong className="fs-5 text-end">
                {Inmate?.FirstName ||
                  inmate?.FirstName ||
                  (inmateInfoTabData && inmateInfoTabData[0]?.FirstName)}
              </strong>
            </div>
          </div>
        </div>

        <div className="row">
          {/* Second Row: Email, State, City */}

          <div className="col-sm-6 col-md-6 col-lg-3 mb-2">
            <div className="form-floating">
              <SelectInput
                options={AccountType}
                value={debit?.AccountTypeId}
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "AccountType")
                }
                isMulti={false}
                closeMenuOnSelect={true}
                isDisabled={false}
                isLoading={false}
                isClearable={false}
                placeholder="Select State"
                label="Account Type"
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-3 mb-2">
            <div className="form-floating">
              <SelectInput
                options={TransactionType}
                value={debit?.TransactionTypeId}
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "TransactionType")
                }
                isMulti={false}
                closeMenuOnSelect={true}
                isDisabled={false}
                isLoading={false}
                isClearable={false}
                placeholder="Select State"
                label="Transaction Type"
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-3 mb-2">
            <div className="form-floating">
              <DateInput
                value={debit?.FromDate}
                handleChange={(e) => handleDateChange(e, "FromDate")}
                name="FromDate"
                label={"From Date"}
                // minDate = {}
                maxDate={debit?.ToDate ? debit?.ToDate : new Date()}
                required={false}
                disabled={false}
                yearDropDown={false}
                monthDropDown={false}
                isClearable={debit?.FromDate ? true : false}
                className={false ? "disabled-date-input" : ""} // Add class conditionally
                minDate={new Date(2017, 0, 1)}
                handleBlur={(e) => handleDateBlur(e, "FromDate")}
                handleKeyDown={(e) => handleDateEnterKey(e, "FromDate")}
              ></DateInput>
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-3 mb-2">
            <div className="form-floating">
              <DateInput
                value={debit?.ToDate}
                handleChange={(e) => handleDateChange(e, "ToDate")}
                name="ToDate"
                minDate={
                  debit?.FromDate ? debit?.FromDate : new Date(2017, 0, 1)
                }
                label={"To Date"}
                maxDate={new Date()}
                required={false}
                disabled={false}
                yearDropDown={false}
                monthDropDown={false}
                isClearable={debit?.ToDate ? true : false}
                handleBlur={(e) => handleDateBlur(e, "ToDate")}
                handleKeyDown={(e) => handleDateEnterKey(e, "ToDate")}
              ></DateInput>
            </div>
          </div>
        </div>

        {/* Buttons */}
        <div className="mt-3 d-flex flex-wrap justify-content-center gap-3">
          <Button
            //variant="danger"
            className="me-2"
            label={"SEARCH"}
            type={"submit"}
            status={"primary"}
            disabled={false}
            icon={"search"}
          ></Button>
          <Button
            variant="danger"
            className="me-2"
            onClick={handleReset} // This will now work correctly
            label={"RESET"}
            type={"button"}
            status={"secondary"}
            disabled={false}
            icon={"fa-solid fa-rotate-right"}
          />
        </div>
      </form>
    );
  };

  return (
    <div>
      <div className="p-2 ">
        <div className="d-flex flex-wrap justify-content-between align-items-center flex-wrap ">
          <h4 className=" inner-subheader-bg text-color">
            <i className="fa fa-history"></i> Debit History
          </h4>
          <Button
            label="Back"
            icon={"fa-solid fa-angle-left"}
            type="button"
            status="primary"
            onClick={() => {
              history.navigate("/Admin/InmateList");
              dispatch(inmateAction.setInmateCurrentTab("inmate-info-tab"));
            }}
          />
        </div>
      </div>
      <div className="card shadow-sm b-r-all p-3 border border-dark-grey mt-1 w-100">
        <div className=" d-block d-md-none">
          <div
            className=" d-flex align-items-center justify-content-between"
            style={{ background: "transparent", cursor: "pointer" }}
            onClick={toggleInformation}
          >
            <h2 className="form_title_uppercase text-color">SEARCH</h2>
            <i
              id="itagInformation"
              className={`fa fa-angle-down ${showSearchFields ? "rotate" : ""}`}
              style={{ fontSize: "20px" }}
            ></i>
          </div>
        </div>
        {/* Mobile only (Below md breakpoint) */}
        <div className="d-block d-md-none">
          {showSearchFields && renderSearch()}
        </div>

        {/* Web only (Desktop and above) */}
        <div className="mb-3 d-none d-md-block">
          <h2 className="form_title_uppercase text-color">SEARCH</h2>
        </div>
        {/* Web only (Desktop and above) */}
        <div className="d-none d-md-block">{renderSearch()}</div>
      </div>

      <div className="mt-3">
        {debitList?.DataList?.length > 0 && (
          <div className="d-flex flex-wrap justify-content-end align-items-center ms-auto mb-2 resp-space ">
            <div className="me-2">
              <PDFExport
                handlePDFExport={handleClickPDF}
                className="btn btn-primary me-2" // Adds margin to the right of this button
              />
            </div>
            <PrintExport
              handlePrintShow={handlePrintShow}
              className="btn btn-primary ms-2" // Adds margin to the left of this button
            />
          </div>
        )}

        {/* Table Section */}

        <Table
          columns={columns}
          data={debitList?.DataList}
          pagination={true}
          totalRowCount={debitList?.TotalRecordCount}
          onChangePage={(e) => handlePageChange(e)} // Call API when page changes
          onChangeRowsPerPage={(e) => handleRowPerPage(e)}
          currentPage={debit?.PageNo}
          paginationPerPage={debit?.RowCountPerPage}
          onSort={handleSort}
          serverSideSort
          sortColumn={debit?.SortBy?.split(" ")[0]}
          sortDirection={debit?.SortBy?.split(" ")[1]}
        />
      </div>
      {/* Print Content */}
      <form
        ref={componentRef}
        style={isPrintData ? { display: "block" } : { display: "none" }}
      >
        {/* Current Date and Time */}
        <div
          style={{
            position: "absolute",
            top: "10px",
            left: "10px",
            fontSize: "12px",
            fontFamily: "Arial, sans-serif",
          }}
        >
          {new Date().toLocaleString()}{" "}
          {/* Dynamically render the current date and time */}
        </div>

        {/* Header Section */}
        <div style={{ textAlign: "center", marginBottom: "10px" }}>
          <h2 style={{ margin: "0" }}>Inmate Debit History</h2>

          {/* Facility Name, Inmate ID, and Inmate Name in a Table Layout */}
          <div
            style={{
              display: "table",
              width: "100%",
              marginTop: "10px",
            }}
          >
            <div style={{ display: "table-row" }}>
              <div
                style={{
                  display: "table-cell",
                  textAlign: "left",
                  padding: "5px",
                }}
              >
                Facility Code: <strong>{FacilityName}</strong>
              </div>
              <div
                style={{
                  display: "table-cell",
                  textAlign: "center",
                  padding: "5px",
                }}
              >
                Inmate Name:{" "}
                <strong>
                  {Inmate?.InmateFullName || inmate?.InmateFullName}
                </strong>
              </div>
              <div
                style={{
                  display: "table-cell",
                  textAlign: "right",
                  padding: "5px",
                }}
              >
                Inmate ID:{" "}
                <strong>{Inmate?.InmateResidentId || inmate?.InmateResidentId}</strong>
              </div>
            </div>
          </div>
        </div>

        {/* Table Section */}
        <div className="table-responsive">
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginTop: "20px",
            }}
            border="1"
          >
            <thead>
              <tr style={{ backgroundColor: "#c8605e", color: "#fff" }}>
                <th style={{ padding: "8px", textAlign: "center" }}>
                  Account Type
                </th>
                <th style={{ padding: "8px", textAlign: "center" }}>
                  Transaction Type
                </th>
                <th style={{ padding: "8px", textAlign: "center" }}>
                  Amount ($)
                </th>
                <th style={{ padding: "8px", textAlign: "center" }}>Date</th>
              </tr>
            </thead>
            <tbody>
              {debitFullList?.DataList?.map((item, index) => (
                <tr key={index}>
                  <td style={{ padding: "8px", textAlign: "center" }}>
                    {item.TransactionFrom}
                  </td>
                  <td style={{ padding: "8px", textAlign: "center" }}>
                    {item.TransactionType}
                  </td>
                  <td style={{ padding: "8px", textAlign: "center" }}>
                    {(item.DebitAmount || 0).toFixed(2)}
                  </td>
                  <td style={{ padding: "8px", textAlign: "center" }}>
                    {item.TransactionDate}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Total Debit and Credit Amount */}

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-end",
            flexDirection: "column", // Stack items vertically
            marginTop: "20px",
            padding: "10px 0",
            fontWeight: "bold",
            fontSize: "14px",
          }}
        >
          <div style={{ textAlign: "left", paddingLeft: "10px" }}>
            Total Debit Amount:{" "}
            <strong>
              ${" "}
              {debitFullList?.DataList?.length > 0 &&
                (debitFullList?.DataList[0]?.DebitTotalAmount).toFixed(2)}
            </strong>
          </div>
          <div style={{ textAlign: "left", paddingLeft: "10px" }}>
            Total Credit Amount:{" "}
            <strong>
              ${" "}
              {debitFullList?.DataList?.length > 0 &&
                (debitFullList?.DataList[0]?.CreditTotalAmount).toFixed(2)}
            </strong>
          </div>
        </div>
      </form>
    </div>
  );
}

export default React.memo(InmateDebitHistory);
